import HomePageContent from "components/layouts/HomePageContent.tsx";

function HomePage(props: { name: string }) {
  const { name } = props;

  return (
    <div>
      <HomePageContent />
    </div>
  );
}

export default HomePage;
